module.exports = __webpack_public_path__ + "static/media/topmate.b86c53b7.svg";